/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-chip-list-title[_ngcontent-%COMP%]{padding-bottom:1%}.mat-chip-list[_ngcontent-%COMP%]{padding-bottom:2%}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary[_ngcontent-%COMP%]{background-color:#20a8d8}  .mat-badge-medium.mat-badge-overlap.mat-badge-after .mat-badge-content{background-color:#20a8d8;width:auto;min-width:-webkit-fill-available}"];
export { styles as styles };
